export default __webpack_public_path__ + "static/media/reset_icon.6073100a.svg";